const AutoIncrementer = require('./auto-incrementer');
const reqIdIncrementer = new AutoIncrementer(1, 1000);

const DEFAULT_MAX_RETRY_COUNT = 2;
const DEFAULT_TIMEOUT_MS = 2000;

class Request {
    constructor(data, maxRetryCount, timeoutMs) {
        this._data = data;
        this._data.req_id = reqIdIncrementer.get();
        this._maxRetryCount = (maxRetryCount !== null && maxRetryCount !== undefined) ? maxRetryCount : DEFAULT_MAX_RETRY_COUNT;
        this._timeoutMs = (timeoutMs !== null && timeoutMs !== undefined) ? timeoutMs : DEFAULT_TIMEOUT_MS;
    }
    
    get data() {
        return this._data;
    }

    get id() {
        return this._data.req_id;
    }

    get maxRetryCount() {
        return this._maxRetryCount;
    }

    get timeoutMs() {
        return this._timeoutMs;
    }

    checkResponse(data) {
        return true;
    }
}

export default Request;